<template>
    <div class="app-scroll-main">
        <!-- 顶部浮动 按钮 OR 工具栏 -->
        <slot name="header"></slot>
        <slot name="headerExtend"></slot>
        <div ref="ScrollPullDown" class="app-scroll-screen" :style="{top: onScrollTop, bottom: scrollBottom, backgroundColor: onScrollBackgroundColor}">
            <div class="app-scroll-container">
                <!-- 正文内容 -->
                <slot name="container"></slot>
                <slot></slot>
                <!-- 正文扩展 -->
            </div>
            <slot name="extend"></slot>
        </div>
        <!-- 底部浮动 按钮 OR 工具栏 -->
        <slot name="footer"></slot>
    </div>
</template>
<script>
    import _ from 'lodash'
    import BScroll from 'better-scroll'
    export default {
        name: 'ScrollPullDown',
        props: {
            onRefreshDelay: {
                type: Number,
                default () {
                    return 0
                }
            },
            onAreMore: {
                type: Boolean,
                default () {
                    return false
                }
            },
            onOptions: {
                type: Object,
                default () {
                    return {}
                }
            },
            onScrollTop: {
                type: String,
                default () {
                    return '0'
                }
            },
            onScrollBackgroundColor: {
                type: String,
                default () {
                    return 'transparent'
                }
            }
        },
        data () {
            return {
                options: {
                    probeType: 2, // 1：滚动的时候会派发scroll事件，会截流。2：滚动的时候实时派发scroll事件，不会截流。 3：除了实时派发scroll事件，在swipe的情况下仍然能实时派发scroll事件
                    click: true, // 点击列表是否派发click事件
                    scrollX: false, // 是否开启横向滚动
                    listenScroll: false, // 是否派发滚动事件
                    listenBeforeScroll: false, // 是否派发滚动事件
                    direction: 'vertical', // 是否派发滚动事件
                    beforeScroll: false, // 是否派发列表滚动开始的事件
                    resizePolling: 60, // 重新调整窗口大小时，重新计算better-scroll的时间间隔
                    eventPassthrough: '', // 忽略滚动的方向
                    freeScroll: false, // 有些场景我们需要支持横向和纵向同时滚动，而不仅限制在某个方向，这个时候我们只要设置 freeScroll 为 true 即可
                    startX: 0, // 开始的X轴位置
                    startY: 0, // 开始的Y轴位置
                    momentum: true, // 当快速滑动时是否开启滑动惯性
                    bounce: true, // 是否启用回弹动画效果
                    HWCompositing: true, // 是否启用硬件加速
                    useTransition: true, // 是否使用CSS3的Transition属性
                    useTransform: true, // 是否使用CSS3的Transform属性
                    preventDefault: true, // 是否阻止默认事件
                    preventDefaultException: { // 阻止默认事件
                        tagName: /^(INPUT|TEXTAREA|SELECT)$/
                    }
                },
                scroll: null,
                config: {
                    refreshDelay: 20, // 当数据更新后，刷新scroll的延时。
                    upHeight: 60, // 默认上拉高度
                    loadState: 0,
                    message: ''
                }
            }
        },
        computed: {
            refreshDelay () {
                return parseInt(this.onOptions.refreshDelay, 10) || 20
            },
            scrollBottom () {
                return this.$store.state.scrollBottom
            }
        },
        methods: {
            onInitScroll () {
                const that = this
                const options = _.cloneDeep(that.options)
                const optionsMap = Object.keys(options)
                const upHeight = parseInt(that.onOptions.upHeight, 10) || that.config.upHeight
                let optionsIndex = 0
                for (; optionsIndex < optionsMap.length; optionsIndex += 1) {
                    const optionsName = optionsMap[optionsIndex]
                    if (Object.prototype.hasOwnProperty.call(that.onOptions, optionsName)) {
                        options[optionsName] = that.onOptions[optionsName]
                    }
                }
                that.scroll = new BScroll(that.$refs.ScrollPullDown, options)
                that.scroll.on('scroll', () => {
                    let height = that.scroll.maxScrollY - that.scroll.y
                    if (!that.onAreMore) {
                        return null
                    }
                    if (height > 20 && height <= upHeight) {
                        if (that.config.loadState !== 1) {
                            that.$store.commit('onChangeAppMessage', '上拉加载更多')
                        }
                        that.config.loadState = 1
                    } else if (height > upHeight) {
                        if (that.config.loadState !== 2) {
                            that.$store.commit('onChangeAppMessage', '松开加载更多')
                        }
                        that.config.loadState = 2
                    }
                })
                that.scroll.on('scrollEnd', () => {
                    that.$store.commit('onChangeAppMessage', '')
                    if (that.config.loadState === 2) {
                        that.config.loadState = 0
                        that.$store.commit('onChangeAppLoaderShow', '正在加载中...')
                        that.$emit('bindPullDown', () => {
                            that.$store.commit('onChangeAppLoaderShow', false)
                        })
                    }
                })
            }
        },
        watch: {
            // 监听数据的变化，延时refreshDelay时间后调用refresh方法重新计算，保证滚动效果正常
            onRefreshDelay () {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.scroll.refresh()
                    }, this.refreshDelay)
                })
            }
        },
        mounted () {
            const that = this
            that.$nextTick(() => {
                setTimeout(() => {
                    that.onInitScroll()
                }, that.refreshDelay)
            })
        }
    }
</script>
<style scoped="">
    .app-scroll-main{ position: absolute; top: 0; right: 0; bottom: 0; left: 0; }
    .app-scroll-screen{ position: absolute; top: 0; right: 0; bottom: 0; left: 0; overflow: hidden; }
    .app-scroll-container{ position: relative; }
</style>



// WEBPACK FOOTER //
// src/public/ScrollPullDown.vue